import { gql } from "@apollo/client";

export const FETCH_ACK_ORDERS_REQUIRED_DATA = gql`
  query FETCH_ACK_ORDERS_REQUIRED_DATA {
    stockCategories {
      id
      name
    }
  }
`;

export const FETCH_WAREHOUSE_STOCK_DATA = gql`
  query FETCH_WAREHOUSE_STOCK_DATA($id: ID!) {
    stockCategory(id: $id) {
      id
      name
      regions
      stocks {
        id
        name
        odooId
        barcode
        number
        asin
        qtyPerMaster
        unitCost
        wisProduct: product {
          id
          images: computedImages(size: "300x300") {
            id
            url
          }
        }
      }
    }
    stockCategoryLatestStocks(stockCategoryId: $id)
  }
`;
